import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';

import { GrClose } from 'react-icons/gr';

import * as S from './Modal.styles';

export const Modal = ({ children, onModalClose }) => {
  if (!children || !onModalClose) {
    return null;
  }

  useEffect(() => {
    function keyListener(event) {
      if (event.keyCode === 27) {
        onModalClose();
      }
    }

    document.addEventListener('keydown', keyListener);

    return () => document.removeEventListener('keydown', keyListener);
  });

  return ReactDOM.createPortal(
    <S.ModalOverlay aria-modal='true' role='dialog'>
      <S.ModalWrapper>
        <S.StyledCross onClick={() => onModalClose()}>
          <GrClose />
        </S.StyledCross>
        <S.ModalContent>{children}</S.ModalContent>
      </S.ModalWrapper>
    </S.ModalOverlay>,
    document.body
  );
};

Modal.propTypes = {
  /**
   * Content of modal.
   */
  children: PropTypes.node.isRequired,
  /**
   * Function closing modal.
   */
  onModalClose: PropTypes.func.isRequired,
};
